import { StepBackward2Icon } from './StepBackward2Icon';

/**
 * author: Simran
 * id 9815CAC2-7390-4AE1-AE72-2B49546987EC
 * name step-backward-2
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/step-backward-2.svg
 * tags
 */
export const FrameBackwardIcon = StepBackward2Icon;
export default FrameBackwardIcon